import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg width="1em" height="1em" viewBox="0 0 8 8" xmlnsXlink="http://www.w3.org/1999/xlink" focusable="false" fill="currentColor" aria-hidden="true"><defs><path id="down-arrow__a" d="M0 0h8v8H0z" /></defs><g fill="none" fillRule="evenodd"><mask id="down-arrow__b" fill="#fff"><use xlinkHref="#down-arrow__a" /></mask><path d="M7.834 2.957 4.4 6.361a.57.57 0 0 1-.8 0L.166 2.957a.557.557 0 0 1 0-.793.569.569 0 0 1 .4-.164h6.868a.558.558 0 0 1 .4.957" fill="#FFF" mask="url(#down-arrow__b)" /></g></svg>

const DownArrow = React.forwardRef((props, ref) => {
  return (
    <IconBase name="down-arrow" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

DownArrow.displayName = 'IconDownArrow'

export default DownArrow
